import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { ApiService } from '../api.service';
import { AppComponent } from '../app.component';
import { AuthService } from '../auth.service';
import { HandlerService } from '../handler.service';
import { LocationService } from '../location.service';

@Component({
  selector: 'app-vendoraddress',
  templateUrl: './vendoraddress.component.html',
  styleUrls: ['./vendoraddress.component.scss'],
})
export class VendoraddressComponent  {
  address:any=[];
  getId;getData;
  loader:boolean=false;
  url;
  userdata:any=[];cityId;regionId;stateId;houseNbr;street;zipcode;lat;lon;
  numCd;fName;lastName;contactNbrMob;

  constructor(public service: ApiService,
    public router: Router,
    public handler: HandlerService,
    public auth: AuthService,
    public app: AppComponent,
     public santinzer: DomSanitizer,
      public platform: Platform,public location: LocationService) { }


      ionViewWillEnter(){
        this.url = window.location.href;
        sessionStorage.setItem('vendorApp','true');
        this.basicDetails();
      
      }
      // save() {
      //   this.address = {
      //     cityId: this.location.cityId,
      //     regionId: this.location.regionId,
      //     stateId: this.location.stateId,
      //     houseNbr: this.location.houseNbr,
      //     street: this.location.street,
      //     zipcode: this.location.zipcode,
      //     lat: this.location.lat,
      //     lon: this.location.lon,
      //     type: 1,
      //     userId: localStorage.getItem('currentUserId'),
      //     orgId: localStorage.getItem('organizationId')
      //   }
      //   this.pinPop = false;
      // }
      basicDetails(){ 
   
        this.loader=true; 
        this.getId=localStorage.getItem('vendoruserId')
 
        this.service.getAddressById(this.getId).subscribe(res => {
     
          this.getData = res;
          this.loader=false;
        });
      }
    
      updateUseredit(){
        this.loader=true;
       var addresses:any=[];
       addresses = {
          cityId: this.location.cityId,
          regionId: this.location.regionId,
          stateId: this.location.stateId,
          houseNbr: this.location.houseNbr,
          street: this.location.street,
          zipcode: this.location.zipcode,
          lat: this.location.lat,
          lon: this.location.lon,
          type: 1,
          userId: localStorage.getItem('vendoruserId'),
          orgId: '790',
        }
        if(!this.getData.addresses)
         Object.assign(this.getData,{addresses:[]})
        if (this.getData.addresses.length == 0)
          this.getData.addresses.push(addresses)
        else{
         let  x=this.getData.addresses.findIndex(res=>res.type==1);
          this.getData.addresses[x]=addresses
        }
        this.service.updateUser1(this.getId,this.getData).subscribe(res =>{
          this.userdata=res;
          this.loader=false; 
          if(this.url.includes('vendoraddress')){
            this.router.navigate(['/account-validate'])
          }  else{
            this.router.navigate(['/user']) 
          }     
        
        })
      }
     
      ionViewWillLeave(){
        this.getData={};
        this.location.cityId='';
        this.location.houseNbr='';
        this.location.lat='';
        this.location.lon='';
        this.location.regionId='';
        this.location.stateId='';
        this.location.street='';
        this.location.zipcode='';
     

      }
    
  
      onInput() {
       this.location.autoComplete();
       }
     next(){
    this.router.navigate(['/vendorProfile'])
     }
}
